'use client';

import { ComponentProps, PropsWithChildren, RefObject, useEffect, useRef } from 'react';
import { useResizeObserver } from 'usehooks-ts';
import { useLayoutDimensionsStore } from '@/lib/providers/LayoutDimensionsStoreProvider';
import { cn } from '@/lib/ui-kit/utils';

type LayoutContainerProps = ComponentProps<'main'> &
  PropsWithChildren & {
    trackDimensions?: boolean;
  };

export const LayoutContainer = ({
  className,
  children,
  trackDimensions = false,
  ...props
}: LayoutContainerProps) => {
  const containerRef = useRef<HTMLElement>(null);
  const { width } = useResizeObserver<HTMLElement>({
    ref: containerRef as RefObject<HTMLElement>,
    box: 'border-box',
  });
  const { setContentWidth } = useLayoutDimensionsStore();

  useEffect(() => {
    if (!trackDimensions) {
      return;
    }
    setContentWidth(width ?? 0);
  }, [setContentWidth, trackDimensions, width]);

  return (
    <main
      className={cn(
        'mx-auto flex w-full max-w-[1464px] flex-col px-4 py-2 sm:px-4 md:px-[60px]',
        className,
      )}
      ref={containerRef}
      {...props}
    >
      {children}
    </main>
  );
};
